/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: 文本输入组件
 */
import { FC, KeyboardEvent } from 'react';

import styles from './index.module.scss';

const MAX_LENGTH = 2000;

interface PromptInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
}

const PromptInput: FC<PromptInputProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder = 'Enter your idea to generate',
}) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (e.metaKey || e.ctrlKey) {
        return;
      }
      e.preventDefault();
      onSubmit?.();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    if (val.length <= MAX_LENGTH) {
      onChange(val);
    }
  };

  return (
    <div className={styles.promptWrapper}>
      <textarea
        className={styles.promptInput}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={4}
      />
      <div className={styles.charCount}>
        {value.length}/{MAX_LENGTH}
      </div>
    </div>
  );
};

export default PromptInput;
